const item = (jersey, type) => `
<div class="inventory-item">
  <div class="inventory-item__picture">
    <img class="item-image inventory-item__image" src="${jersey.image}" />
    <div class="inventory-item__float">
      ${jersey.marketplace_status != 1 ? (`
        <div class="inventory-item__btn ${type ? 'js-add-jersey' : 'js-add-shoe'}" data-jersey_type="${jersey.jersey_type}" data-jersey_id="${jersey.id}" data-shoe_id="${jersey.id}">
          <i class="icon-plus"></i>
        </div>
      `) : ('')}
      <div class="inventory-item__settings">
        <div class="inventory-item__btn"><i class="icon-bars-solid"></i></div>
        <div class="inventory-item__options">
          ${jersey.marketplace_status != 1 ? (`
            <button class="js-put-box-on-marketplace inventory-item__option" data-id="${jersey.id}">
              Sell on Marketplace
            </button>
            <button class="js-transfer-jersey inventory-item__option" data-token-id="${jersey.id}" data-id="${jersey.id}">
              Transfer
            </button>
          `) : (`
            <div class="js-remove-box-from-marketplace inventory-item__option" data-id="${jersey.id}">
              Remove from Marketplace
            </div>
          `)}
        </div>
      </div>
    </div>
  </div>
  <div class="mb-3">${jersey.name}</div>
</div>
`
const templateJerseys = (jerseys, details, shoes) => `
<div class="row">
  ${(details?.jersey || details?.shoe) ? `
    <div class="" style="font-size: 20px; margin-bottom: 10px;">Player Items</div>
  ` : ''}
  <div class="col-12" style="margin-bottom: 40px;">
    <div class="d-flex flex-wrap" style="margin-left: -10px; margin-right: -10px;">
      ${details?.jersey ? (`
          <div class="inventory-item">
            <div class="inventory-item__picture">
              <img class="inventory-item__image" src="${details?.jersey.image}" />
              <div class="inventory-item__float">
                <button class="inventory-item__btn js-remove-jersey" data-jersey_type="${details?.jersey.jersey_type}" data-jersey_id="${details?.jersey.id}">
                  <i class="icon-minus"></i>
                </button>
              </div>
            </div>
            <div>${details?.jersey.name}</div>
          </div>
      `) : ''}
      ${details?.shoe ? (`
          <div class="inventory-item">
            <div class="inventory-item__picture">
              <img class="inventory-item__image" src="${details?.shoe.image}" />
              <div class="inventory-item__float">
                <button class="inventory-item__btn js-remove-shoe" data-shoe_type="${details?.shoe.shoe_type}" data-shoe_id="${details?.shoe.id}">
                  <i class="icon-minus"></i>
                </button>
              </div>
            </div>
            <div>${details?.shoe.name}</div>
          </div>
      `) : ''}
    </div>
  </div>
  ${(jerseys?.length > 0 || shoes?.length > 0) ? `
    <div class="" style="font-size: 20px; margin-bottom: 10px;">Inventory Items</div>
  ` : ''}
  <div class="col-12">
    <div class="d-flex flex-wrap" style="margin-left: -10px; margin-right: -10px;">
      ${[...(jerseys||[])]?.map(jersey => (item(jersey, true))).join('') || ''}
      ${[...(shoes||[])]?.map(shoe => (item(shoe, false))).join('') || ''}
    </div>
  </div>

  ${!details?.jersey?.name && !jerseys ? (`
    <div class="col-12">There has not items</div>
  `) : ''}
</div>
`;

export default templateJerseys;
